<template>
  <div class="ui">
    <div class="pt-2 button menu-button" @click="change_item('request')">
      <h3 class="ui dividing header fdinpro default-header-green is-uppercase">
        Solicitud Bundle
      </h3>
    </div>
    <div class="pt-2 button menu-button" @click="change_item('report')">
      <h3 class="ui dividing header fdinpro default-header-green is-uppercase">
        REPORTES
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "NvidiaTicketNvidiaMenuIzq",
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    change_item(item) {
      this.$emit("change_item", item);
    },
  },
  watch: {},
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.pt-2 {
  padding-top: 2rem !important;
}
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

/*  HEADER    */
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}

/*  HISTORIAL DE ENVIOS */
.menu-button {
  text-align: left !important;
  background-color: transparent !important;
  color: #606060 !important;
  cursor: pointer;
}
.menu-button h3 {
  padding: 3% 2% 0;
}
.menu-button h3:hover {
  color: white !important;
  background-color: #365a0c !important;
}
.menu-button.active {
  color: white !important;
  background-color: #365a0c !important;
}
</style>
